import { render, staticRenderFns } from "./ImportarArquivo.vue?vue&type=template&id=380dfdd8&scoped=true&"
import script from "./ImportarArquivo.vue?vue&type=script&lang=js&"
export * from "./ImportarArquivo.vue?vue&type=script&lang=js&"
import style0 from "./ImportarArquivo.vue?vue&type=style&index=0&id=380dfdd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380dfdd8",
  null
  
)

export default component.exports